import { render, staticRenderFns } from "./AdminDepositBankAccountStatusView.vue?vue&type=template&id=502c9b61&"
import script from "./AdminDepositBankAccountStatusView.vue?vue&type=script&lang=ts&"
export * from "./AdminDepositBankAccountStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports